import './main.scss';
import './styles/tailwind.scss';
import './engine/utils/prototypes';
import './utils/validation/yup-methods';
import {QueryClientProvider} from '@tanstack/react-query';
import {ReactQueryDevtools} from '@tanstack/react-query-devtools';
import ReactDOM from 'react-dom/client';
import {HelmetProvider} from 'react-helmet-async';
import {I18nextProvider} from 'react-i18next';
import {createBrowserRouter} from 'react-router';
import {RouterProvider} from 'react-router/dom';
import {routes} from '@/routes';
import Dialog from './components/dialog';
import NetworkStatusProvider from './contexts/network-status-context';
import environment from './environment';
import i18n from './initializers/i18next';
import queryClient from './initializers/query-client';
import {initialize as initializeSentry} from './initializers/sentry';
import Debug from './routes/debug';

const ROOT_ID = 'root' as const;
const root = document.getElementById(ROOT_ID);
if (!root) {
  throw new Error(`No element with id '${ROOT_ID}' found in HTML`);
}

const hasDebugTools = environment.DEBUG;

initializeSentry();

if (hasDebugTools) {
  routes.unshift({path: '/debug/*', element: <Debug />});
}

const router = createBrowserRouter(routes);

ReactDOM.createRoot(root).render(
  <I18nextProvider i18n={i18n}>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <NetworkStatusProvider>
          <Dialog.SharedBackdropProvider>
            <RouterProvider router={router} />
            <Dialog.SharedBackdrop />
          </Dialog.SharedBackdropProvider>

          {hasDebugTools && <ReactQueryDevtools initialIsOpen={false} />}
        </NetworkStatusProvider>
      </QueryClientProvider>
    </HelmetProvider>
  </I18nextProvider>,
);
